import { Link } from '@starsoft/common/components';
import { SideBarItemSocialMediaProps } from './props';

export default function SideBarItemSocialMedia({
  href,
  faIcon,
}: SideBarItemSocialMediaProps) {
  return (
    <Link href={href} target="_blank">
      <i className={`fa-brands ${faIcon}`} />
    </Link>
  );
}
